import {combineReducers} from 'redux';
import {
  registrationStage,
  registrationUpdatedStage,
  clientRegistrationRestriction,
  clientRegistration,
  clientRegistrationPost,
  clientInfo,
  clientDetails,
  partnerProperties
} from './userInfoReducer';
import { updateDialog } from './dialogReducer';
import { sidebarNav } from './sidebarReducer';
import {
  income,
  paymentDocument,
  notificationsCount,
  contragent ,
  notifications,
  partnerSettings
} from './userDataReducer';
import {
  incomeRegistration,
  jurpersonAdd,
  clientRegistrationUnbind,
  clientRegistrationDelete
} from './sendDataReducer';

export default combineReducers({
  registrationStage,
  registrationUpdatedStage,
  clientRegistrationRestriction,
  clientRegistration,
  clientRegistrationPost,
  clientInfo,
  clientDetails,
  income, updateDialog,
  sidebarNav, paymentDocument,
  notificationsCount, contragent,
  notifications,
  partnerSettings,
  incomeRegistration,
  jurpersonAdd,
  clientRegistrationUnbind,
  clientRegistrationDelete,
  partnerProperties
})